import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { Auth } from './auth';

export const authGuard: CanActivateFn = () => {
  const auth = inject(Auth);
  const router = inject(Router);
  if (auth.isLoggedIn()) {
    // Ensure a profile is selected; if not, force selection
    if (auth.getSelectedProfileId() === null) {
      router.navigate(['/auth/select-profile']);
      return false;
    }
    return true;
  }
  router.navigate(['/auth/login']);
  return false;
};
